import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-guide-checkbox',
  standalone: true,
  imports: [NgIf],
  template: `
    <svg *ngIf="checked" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#02A4FF"/>
    </svg>
    <svg *ngIf="!checked" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3Z" stroke="#CCCCCC" stroke-width="2"/>
    </svg>
  `,
  styles: [':host { display: flex; flex-shrink: 0; }'],
})
export class GuideCheckboxComponent {
  @Input() checked = false;
}
